import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { mergeProps, useCalendarCell, useFocusRing, useLocale } from "react-aria";
import dayjs from "dayjs";
import { getDayOfWeek, isSameDay } from "@internationalized/date";
//#region src/DatePicker/components/Calendar/CalendarCell.tsx
function CalendarCell({ state, date, poolOfDates }) {
	const ref = React.useRef(null);
	const cellInPool = poolOfDates?.includes(dayjs(date.toString()).unix());
	const { cellProps, buttonProps, isSelected, isOutsideVisibleRange, isDisabled, formattedDate, isInvalid } = useCalendarCell({
		date,
		isDisabled: poolOfDates && !cellInPool
	}, state, ref);
	const highlightedRange = state.highlightedRange;
	const isSelectionStart = highlightedRange ? isSameDay(date, highlightedRange.start) : isSelected;
	const isSelectionEnd = highlightedRange ? isSameDay(date, highlightedRange.end) : isSelected;
	const { locale } = useLocale();
	const dayOfWeek = getDayOfWeek(date, locale);
	const isRoundedLeft = isSelected && (isSelectionStart || dayOfWeek === 0 || date.day === 1);
	const isRoundedRight = isSelected && (isSelectionEnd || dayOfWeek === 6 || date.day === date.calendar.getDaysInMonth(date));
	const { focusProps, isFocusVisible } = useFocusRing();
	return /* @__PURE__ */ jsx("td", {
		...cellProps,
		className: cn("relative py-0.5", isFocusVisible ? "z-10" : "z-0"),
		children: /* @__PURE__ */ jsx("div", {
			"data-cy": "calendarCell-div",
			...mergeProps(buttonProps, focusProps),
			ref,
			hidden: isOutsideVisibleRange,
			className: cn("group size-8 outline-none", isRoundedLeft && "rounded-l-full", isRoundedRight && "rounded-r-full", isSelected && (isInvalid ? "bg-red-300" : "bg-tertiary-90"), isDisabled && "text-type-light cursor-not-allowed", poolOfDates && cellInPool && "rounded-lg bg-green-400", poolOfDates && cellInPool && isDisabled && "bg-neutrals-80 rounded-lg"),
			children: /* @__PURE__ */ jsx("div", {
				className: cn("text-type-common flex h-full w-full cursor-default items-center justify-center rounded-lg transition-colors", isDisabled && !isInvalid && "text-neutrals-50", isFocusVisible && "outline-neutrals-80 outline outline-1 -outline-offset-2 group-focus:z-20", isSelectionStart || isSelectionEnd ? isInvalid ? "bg-system-error-50 hover:bg-system-error-50/80 text-white" : "bg-tertiary-70 hover:bg-tertiary-60 text-white" : "", isSelected && !isDisabled && !(isSelectionStart || isSelectionEnd) ? isInvalid ? "hover:bg-red-400" : "hover:bg-tertiary-80" : "", !isSelected && !isDisabled && "hover:bg-neutrals-90 cursor-pointer", cellInPool && !isDisabled && "text-white hover:bg-green-500"),
				children: formattedDate
			})
		})
	});
}
//#endregion
export { CalendarCell };

//# sourceMappingURL=CalendarCell.js.map